import { Table as MuiTable } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const Table = ({ children, className, ...props }) => {
  const { classes, cx } = useStyles(styles);

  return (
    <MuiTable className={cx(classes.table, className)} {...props}>
      {children}
    </MuiTable>
  );
};

const styles = () => ({
  table: {
    borderCollapse: 'separate',
  },
});

Table.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Table;
